import React from "react";
import { NavLink, Link } from "react-router-dom";
import { Coins, Camera, ChartLineUp, Gear, SignOut, MapPin } from "@phosphor-icons/react";
import { useAuth } from "../lib/auth";

export default function Navbar() {
  const { user, logout } = useAuth();
  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-40 bg-[#F9F8F6]/85 backdrop-blur-xl border-b border-black/5"
    >
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-4 flex items-center justify-between gap-3">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-link">
          <span className="inline-flex h-9 w-9 items-center justify-center bg-[#9C5B42] text-white">
            <Coins weight="duotone" size={20} />
          </span>
          <div className="leading-tight">
            <div className="font-serif text-2xl text-[#1E2520]">Reperti</div>
            <div className="label-eyebrow">{user?.role === "owner" ? "Proprietario" : "Editor"}</div>
          </div>
        </Link>

        <nav className="flex items-center gap-3 sm:gap-6 md:gap-8 text-sm font-medium">
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              `transition-colors flex items-center gap-1.5 ${isActive ? "text-[#9C5B42]" : "text-[#1E2520] hover:text-[#9C5B42]"}`
            }
            data-testid="nav-catalog"
            title="Catalogo"
          >
            <Coins weight="duotone" size={18} className="md:hidden" />
            <span className="hidden md:inline">Catalogo</span>
          </NavLink>
          <NavLink
            to="/stats"
            className={({ isActive }) =>
              `transition-colors flex items-center gap-1.5 ${
                isActive ? "text-[#9C5B42]" : "text-[#1E2520] hover:text-[#9C5B42]"
              }`
            }
            data-testid="nav-stats"
            title="Statistiche"
          >
            <ChartLineUp weight="duotone" size={18} />
            <span className="hidden md:inline">Statistiche</span>
          </NavLink>
          <NavLink
            to="/map"
            className={({ isActive }) =>
              `transition-colors flex items-center gap-1.5 ${
                isActive ? "text-[#9C5B42]" : "text-[#1E2520] hover:text-[#9C5B42]"
              }`
            }
            data-testid="nav-map"
            title="Mappa"
          >
            <MapPin weight="duotone" size={18} />
            <span className="hidden md:inline">Mappa</span>
          </NavLink>
          <NavLink
            to="/settings"
            className={({ isActive }) =>
              `transition-colors flex items-center gap-1.5 ${
                isActive ? "text-[#9C5B42]" : "text-[#1E2520] hover:text-[#9C5B42]"
              }`
            }
            data-testid="nav-settings"
            title="Impostazioni"
          >
            <Gear weight="duotone" size={18} />
            <span className="hidden md:inline">Impostazioni</span>
          </NavLink>
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/scan"
            className="btn-primary inline-flex items-center gap-2 text-sm"
            data-testid="nav-scan-button"
          >
            <Camera weight="duotone" size={18} />
            <span className="hidden sm:inline">Identifica</span>
          </Link>
          {user && (
            <button
              onClick={logout}
              className="text-[#5C635A] hover:text-[#1E2520] p-2"
              title={`Esci (${user.email})`}
              data-testid="logout-btn"
            >
              <SignOut weight="duotone" size={20} />
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
